import NewDesign from 'components/NewDesign';
import useToggleDialog from 'hooks/useToggleDialog';
import React from 'react';
import Props from '../../Components/Props';
import FormikFields from 'components/FormikFields';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import JSXCode from '../../Components/JSXCode';

const TabDialog = (props) => {
  //! State
  const { t } = useTranslation();
  const [openDialog, toggleDialog, shouldRenderDialog] = useToggleDialog();
  const [openDialogWithForm, toggleDialogWithForm, shouldRenderDialogWithForm] = useToggleDialog();

  //! Function

  //! Render
  return (
    <div className='component:TabDialog'>
      {shouldRenderDialog && (
        <NewDesign.Dialog
          isOpen={openDialog}
          toggle={toggleDialog}
          header={'Dialog Header'}
          content={`Hi I'm dialog ^^`}
          footer='Noooo'
        />
      )}

      <NewDesign.Button onClick={toggleDialog} className='tw-mb-2'>
        Click to open Dialog
      </NewDesign.Button>

      <JSXCode
        code={`const [openDialog, toggleDialog, shouldRenderDialog] = useToggleDialog();

return (
        <div>
            {shouldRenderDialog && (
                <NewDesign.Dialog
                        isOpen={openDialog}
                        toggle={toggleDialog}
                        header={'Dialog Header'}
                        content={"Hi I'm dialog ^^"}
                        footer='Noooo'
            />)}
        </div>
)
`}
      />

      <NewDesign.Button onClick={toggleDialogWithForm} variant='secondary' className='tw-my-2'>
        Click to open Dialog with Form
      </NewDesign.Button>

      {shouldRenderDialogWithForm && (
        <NewDesign.Dialog
          isOpen={openDialogWithForm}
          toggle={toggleDialogWithForm}
          form={{
            initialValues: {
              username: '',
              password: '',
            },
            onSubmit: (values, { setSubmitting }) => {
              setSubmitting(true);
              alert(JSON.stringify(values));
              setSubmitting(false);
            },
            validationSchema: Yup.object().shape({
              username: Yup.string().required('Username is required field!'),
              password: Yup.string().required('Password is required field!'),
            }),
          }}
          header='Dialog Form'
          content={(formikHelpers) => {
            const { values } = formikHelpers;
            return (
              <div>
                <code>{JSON.stringify(values)}</code>
                <div className='tw-flex tw-my-2 tw-flex-col tw-gap-2'>
                  <FormikFields.Input
                    name='username'
                    label='Username'
                    placeholder='Type username'
                    required
                  />
                  <FormikFields.Input
                    name='password'
                    label='Password'
                    placeholder='Type password'
                    type='password'
                    required
                  />
                </div>
              </div>
            );
          }}
          footer={(formikHelpers) => {
            const { toggle, isSubmitting } = formikHelpers;

            return (
              <Fragment>
                <NewDesign.Button isLoading={isSubmitting} type='submit'>
                  Submit
                </NewDesign.Button>
                <NewDesign.Button type='button' variant='ghost' onClick={toggle}>
                  {t('shared:close')}
                </NewDesign.Button>
              </Fragment>
            );
          }}
        />
      )}

      <JSXCode
        code={`const [openDialog, toggleDialog, shouldRenderDialog] = useToggleDialog();

return (
    <div>
      {shouldRenderDialog && (
        <NewDesign.Dialog
            isOpen={openDialog}
            toggle={toggleDialog}
            form={{
                initialValues: {
                    username: '',
                    password: '',
                },
                onSubmit: (values, { setSubmitting }) => {
                    setSubmitting(true);
                    alert(JSON.stringify(values));
                    setSubmitting(false);
                },
                validationSchema: Yup.object().shape({
                    username: Yup.string().required('Username is required field!'),
                    password: Yup.string().required('Password is required field!'),
                }),
            }}
            header='Dialog Form'
            content={(formikHelpers) => {
                const { values } = formikHelpers;
                return (
                    <div>
                        <code>{JSON.stringify(values)}</code>
                        <div className='tw-flex tw-my-2 tw-flex-col tw-gap-2'>
                        <FormikFields.Input
                            name='username'
                            label='Username'
                            placeholder='Type username'
                            required
                        />
                        <FormikFields.Input
                            name='password'
                            label='Password'
                            placeholder='Type password'
                            type='password'
                            required
                        />
                        </div>
                    </div>
                );
            }}
            footer={(formikHelpers) => {
                const { toggle, isSubmitting } = formikHelpers;

                return (
                    <Fragment>
                        <NewDesign.Button isLoading={isSubmitting} type='submit'>
                            Submit
                        </NewDesign.Button>
                        <NewDesign.Button type='button' variant='ghost' onClick={toggle}>
                        {t('shared:close')}
                        </NewDesign.Button>
                    </Fragment>
                );
            }}
        />
      )}
    </div>
)
`}
      />

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'isOpen',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'toggle',
            type: 'func',
            default: 'undefined',
          },
          {
            prop: 'header',
            type: '"JSX" | "number" | "string" | ({ ...formikHelpers, toggle }) => void',
            default: 'undefined',
          },
          {
            prop: 'content',
            type: '"JSX" | "number" | "string" | ({ ...formikHelpers, toggle }) => void',
            default: 'undefined',
          },
          {
            prop: 'footer',
            type: '"JSX" | "number" | "string" | ({ ...formikHelpers, toggle }) => void',
            default: 'undefined',
          },
          {
            prop: 'className',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'mode',
            type: '"from-right" | "from-left"',
            default: 'undefined',
          },
          {
            prop: 'form',
            type: '{ "initialValues": Object, "onSubmit": (values, { ...formikHelpers, toggle }) => void, "validationSchema": any, "validateOnChange": boolean, "validateOnBlur": boolean }',
            default: 'undefined',
          },
        ]}
      />
    </div>
  );
};

export default TabDialog;
